import Sidebar from "../components/Sidebar/Sidebar";
import ChatWindow from "../components/ChatWindow/ChatWindow";
import styles from "./chatpage.module.css";
import Header from "../components/Header";
import { useMsal } from "@azure/msal-react";

import React, { useState } from "react";
import { useMediaQuery } from "@mui/material";

export default function ChatPage() {
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const [sidebarOpen, setSidebarOpen] = useState(isTablet ? false : true);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userEmail = activeAccount?.username || "Unknown User";

  const handleLogout = async () => {
    try {
      await instance.logoutPopup({
        postLogoutRedirectUri: "/", // redirect to login/landing
      });
      window.location.href = "/"; // force reload to clear session
    } catch (err) {
      // Logout failed - user will be redirected anyway
    }
  };
  return (
    <>
      <div className={styles.chatpageContainer}>
        <Sidebar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
        />
        <div className={styles.mainContent}>
          <Header
            isShowThemeToggle={true}
            userName={userEmail}
            onClickLogout={handleLogout}
            isSidebarOpen={() => setSidebarOpen(!sidebarOpen)}
          />
          <ChatWindow />
        </div>
      </div>
    </>
  );
}
